import React from 'react';
import { TeamLoginForm } from '@/components/auth/TeamLoginForm';

const TeamLoginPage: React.FC = () => {
  return <TeamLoginForm />;
};

export default TeamLoginPage;
